import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "register-form-row" }
const _hoisted_3 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_4 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_5 = { class: "register-form-row" }
const _hoisted_6 = {
  value: '',
  selected: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  value: '',
  selected: ""
}
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_15 = { class: "register-form-row" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  value: '',
  selected: ""
}
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1)
const _hoisted_20 = {
  key: 2,
  class: "error-msg"
}
const _hoisted_21 = {
  key: 3,
  class: "error-msg"
}
const _hoisted_22 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_23 = { class: "register-form-row" }
const _hoisted_24 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_25 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_26 = { class: "register-form-foot register-form-foot--alt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!

  return (_openBlock(), _createElementBlock("form", {
    class: "register-form form",
    onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("h3", {
      class: "register-form-title h4",
      innerHTML: _ctx.$t('staff-form.step2-description')
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.business')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.business) = $event)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.business.$touch && _ctx.v$.business.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.business.$errors.length }),
          type: "text",
          name: "business",
          minlength: "2",
          maxlength: "255",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.business]
        ]),
        (_ctx.v$.business.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.v$.business.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.position')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.position) = $event)),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.position.$touch && _ctx.v$.position.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.position.$errors.length }),
          type: "text",
          name: "position",
          minlength: "2",
          maxlength: "255",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.position,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.position.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.v$.position.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.country')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.country) = $event)),
          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.country.$touch && _ctx.v$.country.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.country.$errors.length }),
          name: "country"
        }, [
          _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t('staff-form.select')) + ".", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (countryItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: countryItem.id,
              value: countryItem.id
            }, _toDisplayString(countryItem.name), 9, _hoisted_7))
          }), 128))
        ], 34), [
          [_vModelSelect, _ctx.country]
        ]),
        _hoisted_8,
        (_ctx.v$.country.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.v$.country.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.state')), 1),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state) = $event)),
          disabled: _ctx.country !== 230,
          onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.state.$touch && _ctx.v$.state.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.state.$errors.length }),
          name: "state"
        }, [
          _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('staff-form.select')) + ".", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (stateItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: stateItem.id,
              value: stateItem.id
            }, _toDisplayString(stateItem.name), 9, _hoisted_12))
          }), 128))
        ], 42, _hoisted_10), [
          [_vModelSelect, _ctx.state]
        ]),
        _hoisted_13,
        (_ctx.v$.state.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.v$.state.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('register-form.city')), 1),
        (_ctx.country === 230)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("select", {
                disabled: _ctx.state === '' || !_ctx.cities.length,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.cityId) = $event)),
                onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.cityId.$touch && _ctx.v$.cityId.$touch(...args))),
                class: _normalizeClass({ 'error': _ctx.v$.cityId.$errors.length }),
                name: "cityId"
              }, [
                _createElementVNode("option", _hoisted_17, _toDisplayString(_ctx.$t('register-form.select')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, (cityItem) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: cityItem.id,
                    value: cityItem.id
                  }, _toDisplayString(cityItem.name), 9, _hoisted_18))
                }), 128))
              ], 42, _hoisted_16), [
                [_vModelSelect, _ctx.cityId]
              ]),
              _hoisted_19
            ], 64))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.city) = $event)),
              onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.city.$touch && _ctx.v$.city.$touch(...args))),
              class: _normalizeClass({ 'error': _ctx.v$.city.$errors.length }),
              type: "text",
              name: "city",
              maxlength: "255",
              required: "",
              spellcheck: "false",
              autocorrect: "off"
            }, null, 34)), [
              [
                _vModelText,
                _ctx.city,
                void 0,
                { trim: true }
              ]
            ]),
        (_ctx.country !== 230 && _ctx.v$.city.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.v$.city.$errors[0].$message), 1))
          : _createCommentVNode("", true),
        (_ctx.country === 230 && _ctx.v$.cityId.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.v$.cityId.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.address')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.address) = $event)),
          onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.address.$touch && _ctx.v$.address.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.address.$errors.length }),
          type: "text",
          name: "address",
          maxlength: "255",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [
            _vModelText,
            _ctx.address,
            void 0,
            { trim: true }
          ]
        ]),
        (_ctx.v$.address.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.v$.address.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.zip')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.zip) = $event)),
          onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.zip.$touch && _ctx.v$.zip.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.zip.$errors.length }),
          type: "text",
          name: "zip",
          minlength: "4",
          maxlength: "12",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.zip]
        ]),
        (_ctx.v$.zip.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.v$.zip.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("fieldset", null, [
        _createElementVNode("legend", null, _toDisplayString(_ctx.$t('staff-form.phone')), 1),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.phone) = $event)),
          onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.v$.phone.$touch && _ctx.v$.phone.$touch(...args))),
          class: _normalizeClass({ 'error': _ctx.v$.phone.$errors.length }),
          type: "text",
          name: "phone",
          placeholder: "Phone Number",
          required: "",
          spellcheck: "false",
          autocorrect: "off"
        }, null, 34), [
          [_vModelText, _ctx.phone]
        ]),
        (_ctx.v$.phone.$errors.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.v$.phone.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('prevTab'))),
        type: "button",
        class: "link-secondary text-lg"
      }, _toDisplayString(_ctx.$t('register-form.back')), 1),
      _createVNode(_component_ButtonHover, {
        type: "submit",
        class: "button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('register-form.next')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"])
  ], 32))
}